export default {
    xs: '8px',
    s: '16px',
    m: '24px',
    l: '48px',
    xl: '72px',
};
